<template>
  <div class="grid-container" :class="{'grid-container__joker': unit === gUnit.joker}" v-if="methods.length && customerShopPackages.length">

    <div class="buy-credits__title-payment title title--smedium">
      {{ trans.get('ms:shop.choose_payment') }}
    </div>
    <div class="buy-credits__payment">
      <label v-for="(method, index) in methods" :key="index" :class="{'mobile-centered': index%2 === 0 && index === methods.length-1}">
        <input v-model="methodId" name="payment_method" type="radio" class="radio__icon" :value="method.id">
        <a
          v-show="method.id !== methodId"
          class="button button__icon-flex button__icon-image not-active-method"
          :class="`payment_method_id_${method.id}`"
          :title="method.name"
          v-html="method.image_inactive"
        >
        </a>
        <a
          v-show="method.id === methodId"
          class="button button__icon-flex button__icon-image active-method"
          :class="`payment_method_id_${method.id}`"
          :title="method.name"
          v-html="method.image"
        >
        </a>
      </label>
    </div>

    <div class="buy-credits__method-info p-0">
      <transition name="fade">
        <div v-if="methodId === 7" class="px-3 py-1">
          <i class="icon-demo icon-warning" aria-hidden="true"></i>
          <span class="font-9 small">{{ trans.get('ms:shop.delay_info') }}</span>
        </div>
      </transition>
    </div>

    <voucher v-model="voucherData" :unit="unit"></voucher>

    <div class="buy-credits__title-header title title--small" v-if="unit === gUnit.coin">{{ trans.get('ms:shop.coins_package') }}</div>
    <div class="buy-credits__title-header title title--small" v-if="unit === gUnit.joker">{{ trans.get('ms:shop.joker_package') }}</div>
    <template v-for="shopPackage in customerShopPackages">
      <transition name="fade">
        <PackageElement
          :key="shopPackage.id"
          :shopPackage="shopPackage"
          :fee="currentMethod.fee"
          @buy="buy"
          :voucher="voucherData ? {discount: voucherData.discount, type: voucherData.type} : null"
          :loading="loading"
        >
        </PackageElement>
      </transition>
    </template>
  </div>
</template>

<script>
import PackageElement from './PackageElement';
import Voucher from './Voucher';
import { mapGetters } from 'vuex';

export default {
  name: 'PaymentComponent',
  components: { Voucher, PackageElement },
  props: {
    unit: {
      type: String,
      required: true,
      validator: function (value) {
        return ['coin', 'joker'].indexOf(value) !== -1;
      }
    },
    cid: {
      type: String,
      required: false,
    },
  },
  data() {
    return {
      methods: [],
      methodId: null,
      voucherData: null,
      gUnit: {
        coin: window.globals.customer_shop_package.unit_coin,
        joker: window.globals.customer_shop_package.unit_joker,
      },
      loading: false,
    };
  },
  computed: {
    ...mapGetters('user', {
      user: 'getUser',
    }),
    currentMethod: function () {
      if (this.methodId) {
        return this.methods.find((el) => el.id === this.methodId);
      }
      return null;
    },
    customerShopPackages: function () {
      if (this.currentMethod) {
        return this.currentMethod.customer_shop_packages;
      }
      return [];
    },
  },
  watch: {},
  methods: {
    fetchData: function () {
      axios
        .get(zRoute('ajax.payment.index', {
          unit: this.unit,
          service: 'WEB',
          user_id: this.user.id,
        }))
        .then((response) => {
          this.methods = response.data.data;
          if (this.methodId === null)
            this.methodId = this.methods[0].id;
        });
    },
    buy: function ({ package_id, price }) {
      this.loading = true;

      axios
        .post(zRoute('ajax.payment.store'), {
          customer_shop_package_id: package_id,
          price: price,
          payment_method_id: this.methodId,
          voucher_id: this.voucherData ? this.voucherData.id : null,
          cid: this.cid,
        })
        .then((response) => {
          localStorage.setItem('last_payment_price', price);
          window.location.href = response.data.redirect_url;
        })
        .catch((error) => {
          this.loading = false;

          // show notification
          this.$notify({
            group: 'custom-template',
            type: 'error',
            title: 'Error',
            text: error.response.data.message,
            duration: 5000,
            data: {},
          });
        })
        .finally(() => {

        });

      this.$store.dispatch('analytics/gtagEvent', {
        event: 'front_purchase',
        p: {
          'event_category': 'Shop',
          'event_label': 'Initiate purchase',
          'package': package_id,
          'method': this.methodId,
          'value': price
        }
      });
    },
  },
  mounted() {
    this.fetchData();
  }
};
</script>
<style>
.fade-enter-active, .fade-leave-active {
  transition: opacity 0.25s ease-out;
}

.fade-enter, .fade-leave-to {
  opacity: 0;
}

</style>
